import { render } from "./CusineSale.vue?vue&type=template&id=f8d5b168&scoped=true"
import script from "./CusineSale.vue?vue&type=script&lang=js"
export * from "./CusineSale.vue?vue&type=script&lang=js"

import "./CusineSale.vue?vue&type=style&index=0&id=f8d5b168&lang=css"
import "./CusineSale.vue?vue&type=style&index=1&id=f8d5b168&scoped=true&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d5b168"]])

export default __exports__